<template>
  <div
    class="sb-switch-button-group-switch"
    data-sb-regression="sb-button-group-switch"
  >
    <label
      :id="id"
      :class="['switch-wrapper', isDisabled ? 'disabled': '']"
    >
      <button
        ref="inactive_toggle"
        data-sb-automation="inactive-toggle"
        :class="['btn', isChecked === false ? 'active': '', isChecked === null ? 'no-value-selected':'' ]"
        :aria-label="$t(toggleOffText)"
        :aria-pressed="isChecked === null ? 'mixed' : !isChecked ? true : false"
        @click="handleSwitchClick(false)"
      >
        <sb-text :value="toggleOffText" />
      </button>
      <input
        :aria-labelledby="id"
        type="checkbox"
        :checked="isChecked"
      >
      <button
        data-sb-automation="active-toggle"
        :class="['btn', isChecked === true ? 'active': '' ]"
        :aria-label="$t(toggleOnText)"
        :aria-pressed="isChecked === null ? 'mixed' : isChecked ? true : false"
        @click="handleSwitchClick(true)"
      >
        <sb-text :value="toggleOnText" />
      </button>
    </label>
  </div>
</template>

<script>

import uuid from '@src/utils/uuid';
import SbText from '@src/components/Text/SbText.vue';

/**
 * Switch components allow the user to select on or off.
 * This acts like a checkbox but in a different more visible styling.
 */
export default {
  name: 'SbButtonGroupSwitch',
  components: {
    SbText,
  },
  props: {
    /**
     * enabled or disabled
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * If the option is on or off
     */
    checked: {
      type: Boolean,
      default: null,
    },
    /**
     * Text to show when the switch is on
     */
    toggleOnText: {
      type: String,
      default: 'common.active',
    },
    /**
     * Text to show when the switch is off
     */
    toggleOffText: {
      type: String,
      default: 'common.inactive',
    },
  },
  emits: [
    /**
     * Emitted when switch component is clicked on.
     * @param {bool} value
     */
    'sb-button-group-switch-on-click',
  ],
  data: () => {
    return {
      id: null,
      isChecked: null,
    };
  },
  mounted() {
    this.id = uuid();
    this.isChecked = this.checked;
  },
  methods: {
    handleSwitchClick(value) {
      this.isChecked = value;

      this.$emit('sb-button-group-switch-on-click', value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@src/components/Switch/style/sb-button-group-switch.scss';
</style>
